module.exports = __webpack_public_path__ + "img/E143.306b73e0.svg";